/**
 * formats 1321300.13 to 1.321.300,13
 * @param num
 */
export function formatCommaEuroToDottedComma(num: number): string {
  const [euro, cent] = num.toFixed(2).toString().split(".");

  const euroDigits = euro.split("");
  const centDigits = cent.toString();

  let dottedEuro = "";
  let ctr = 0;
  euroDigits.reverse().forEach((d) => {
    dottedEuro = d + dottedEuro;
    ctr++;
    if (ctr % 3 === 0 && ctr !== euroDigits.length) {
      dottedEuro = "." + dottedEuro;
    }
  });

  return dottedEuro + "," + centDigits;
}

/**
 * Formats a number with German locale (de-DE).
 * @param value - the number to format (null/undefined treated as 0)
 * @param maximumFractionDigits - max decimal places (default 1)
 * @param minimumFractionDigits - min decimal places (default 0)
 */
export function formatNumber(
  value: number | null | undefined,
  maximumFractionDigits = 1,
  minimumFractionDigits = 0
): string {
  return (value ?? 0).toLocaleString("de-DE", { maximumFractionDigits, minimumFractionDigits });
}
